"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importSmartHRDepartments = importSmartHRDepartments;
exports.smartHRAttendanceTokenPatchRequest = smartHRAttendanceTokenPatchRequest;
const webappApi_1 = require("../webappApi/v2/webappApi");
async function importSmartHRDepartments(activeUserId, activeBranchId) {
    const url = `/dashboard/${activeUserId}/smarthr/department_import?c=${activeBranchId}`;
    try {
        return await (0, webappApi_1.requestWrapper)(async () => await fetch(url, {
            method: "POST",
        }));
    }
    catch (err) {
        throw err;
    }
}
async function smartHRAttendanceTokenPatchRequest(userId, branchId, token) {
    const url = `/dashboard/${userId}/user/smarthr_attendance_access_token?c=${branchId}`;
    const data = new URLSearchParams({
        accessToken: token,
    });
    return await fetch(url, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: data.toString(),
    });
}
